import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-table-scrollable"]

import type { Theme } from "../types/theme";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-table',
  props: {
    isScrollable: { type: Boolean, default: false },
    isResponsive: { type: Boolean, default: false },
    theme: { default: "light" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.isScrollable)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ds-table-scrollable-wrapper", { 'ds-table-scrollable-wrapper--responsive': _ctx.isResponsive }])
      }, [
        _createElementVNode("table", {
          class: _normalizeClass(["ds-table", { 'ds-table--dark': _ctx.theme === 'dark' }]),
          "data-table-scrollable": _ctx.isScrollable
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_1)
      ], 2))
    : (_openBlock(), _createElementBlock("table", {
        key: 1,
        class: _normalizeClass(["ds-table", { 'ds-table--dark': _ctx.theme === 'dark' }])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2))
}
}

})